



















import { useState, useEffect } from "react";
import ActionCol from "./action-col";
import "./list.css";
import { formatDateTime } from "../../utils/fn";

const token = localStorage.getItem("zTaskAuthToken");

const ListView = ({ 
  listApi, 
  tableFields, 
  uriBasePath, 
  preloadedData = null, 
  skipDataFetch = false 
}) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(!skipDataFetch);
  const [error, setError] = useState(null);

  useEffect(() => {
    // If preloaded data is provided, use it directly
    if (preloadedData !== null) {
      setData(preloadedData);
      setIsLoading(false);
      return;
    }

    // If skipDataFetch is true, don't fetch
    if (skipDataFetch) {
      setIsLoading(false);
      return;
    }

    // Otherwise, fetch data from API
    const fetchData = async () => {
      try {
        setIsLoading(true);
        setError(null);

        const response = await fetch(listApi, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(
            `HTTP error! status: ${response.status} - ${errorText}`
          );
        }

        const result = await response.json();

        setData(result);
      } catch (err) {
        console.error("Error fetching list data:", err);
        setError("Failed to load data. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [listApi, preloadedData, skipDataFetch]);

  return (
    <div className="list-container">
      {isLoading && <p className="loading-message">Loading data...</p>}
      {error && <p className="error-message">{error}</p>}

      {!isLoading && !error && data.length === 0 && (
        <p className="no-data-message">
          No data found. Click "New" to add an item.
        </p>
      )}

      {!isLoading && !error && data.length > 0 && (
        <div className="table-container">
          <table>
            <thead>
              <tr>
                {tableFields.map((field) => (
                  <th key={field.fieldName}>{field.displayName}</th>
                ))}
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, rowIndex) => (
                <tr key={row.id || rowIndex}>
                  {tableFields.map((field) => (
                    <td key={field.fieldName}>
                      {field.render
                        ? field.render(row[field.fieldName], row)
                        : !isNaN(new Date(row[field.fieldName]).getTime()) &&
                          typeof row[field.fieldName] === "string"
                        ? formatDateTime(row[field.fieldName])
                        : row[field.fieldName]}
                    </td>
                  ))}
                  <td>
                    <ActionCol row={row} uriBasePath={uriBasePath} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ListView;